import template from './forbiddenPage.html';
import controller from './forbiddenPage.controller';
import './forbiddenPage.scss';

let forbiddenPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default forbiddenPageComponent;
